import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.min";
import 'select2/dist/css/select2.min.css';
import 'jquery/dist/jquery.min';
import 'select2/dist/js/select2.min';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'font-awesome/css/font-awesome.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import configureStore from "./store";
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
//Ref: https://ej2.syncfusion.com/react/documentation/licensing/license-key-registration
registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5Vd0BiUHxcdHNUQ2ddWkZ/;Mgo+DSMBMAY9C3t2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5Vd0BiUHxcdHNUTmhfWkZ/;MzkwNjkxMkAzMjM5MmUzMDJlMzAzYjMyMzkzYkswTmVlVlV1VnJ5MXo1aHYzWEtidDFlN2ZuOUJJRmJ0dzhRQ2ZPR2RSTGc9');

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <Provider store={configureStore()}>
        <Router basename={baseUrl}>
            <App />
        </Router>
    </Provider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
